import i18n from '@/utils/i18n';
import React from 'react';
import {
  CUSTOMERS_TABLE_COLUMNS,
  CUSTOMERS_TABLE_ROW_HEIGHT,
} from '@finance-hub/domain/customers/components/customers-table-columns';
import {
  Separator,
  Skeleton,
  View,
  XStack,
  YStack,
} from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

const SKELETON_BAR_HEIGHT = 14;
const SKELETON_BAR_WIDTH = 88;

interface Props {
  count: number;
}

export const CustomersTableSkeletonRows: React.FC<Props> = ({ count }) => {
  const theme = useTheme();

  return (
    <YStack accessibilityLabel={i18n.t('loading')} width="100%">
      {Array.from({ length: count }, (_, index) => (
        <React.Fragment key={`skeleton-row-${index}`}>
          <XStack
            alignItems="center"
            minHeight={CUSTOMERS_TABLE_ROW_HEIGHT}
            paddingVertical="$16"
          >
            {CUSTOMERS_TABLE_COLUMNS.map((column) => (
              <View
                key={column.id}
                paddingHorizontal="$8"
                width={`${column.initialPercentWidth}%`}
              >
                <Skeleton
                  borderRadius={theme.sk.radii.radiusRound}
                  height={SKELETON_BAR_HEIGHT}
                  maxWidth="100%"
                  variant="rect"
                  width={SKELETON_BAR_WIDTH}
                />
              </View>
            ))}
          </XStack>
          <Separator />
        </React.Fragment>
      ))}
    </YStack>
  );
};
